<template>
<div>
    <h2>Team members</h2>

    <div
        v-if="profile.rate_card.included_users == 1"
    >
        Your current subscription plan includes one user &mdash; any additional users will be billed at the rate of {{profile.rate_card.cost_per_extra_user}} per user per month.
    </div>
    <div
        v-else
    >
        Your current subscription plan includes {{profile.rate_card.included_users}} users &mdash; additional users (in excess of the {{profile.rate_card.included_users}} included users) are billed at the rate of {{profile.rate_card.cost_per_extra_user}} per user per month.
    </div>
    

    <m-settings-organization-team-members
        :profile="profile"
        :show_search_bar="false"
        style="margin-bottom: 30px"
        :simple_create_team_member_dialog="true"
        v-on:add-team-member="addTeamMember"
        v-on:patch-employee="onPatchEmployee"
    />

    <p>
        <v-switch
            label="The list of team members is ready for launch"
            v-model="profile.setup_tasks.setup_team_members_complete"
            v-on:change="onChangeReadySwitch"
        />
    </p>
    
</div>
</template>

<script>
export default {
    props: {
        profile: {
            type: Object,
            default: null,
        },
    },

    methods: {
        onChangeReadySwitch(value) {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/welcome/tasks/setup_team_members_complete',
            
                'params' : {
                        'employee_id': this.profile.employee_account.employee_id,
                        'value': value,
                    },
            
                'on_success': (data) => {
                        this.$emit('update-profile',data);

                        if ( value == true )
                        {
                            this.sendProgressAlert();
                        }
                    },
            
                'on_error': 'Unable to update settings',
            });
        },

        onPatchEmployee(changes)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.$emit('reload-profile');
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },

        sendProgressAlert()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/send-progress-alert',
            
                'params' : {
                        'organization_id': this.profile.employee_account.organization_id,
                        'alert_pattern': '{organization-label} has setup their team members'
                    },
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': () => {},
            });
        },

        addTeamMember(new_team_member_data)
        {
            this.$rc.createEmployee(
                new_team_member_data, 
                () => {
                    this.$emit('reload-profile');
                },
                (message) => { 
                    this.show_loading = false;
                    alert(message) 
                } 
            );
        },
    },

    computed: 
    {
        organization_id()
        {
            return this.$rc.getDeep(this.profile,'organization_account/organization_id');
        }
    },
}
</script>

<style lang="scss" scoped>

</style>